import { isArrayNotEmpty, NomenclatureAutocompleteFormField } from "@duosoftbg/nacid-components";
import { useFormContext, useWatch } from "react-hook-form";
import useAppSelector from "../../../../../hooks/redux/base/useAppSelector";
import { nationalUniversitiesDataThunk } from "../../../../../store/redux/slice/AppData/nationalUniversities";
import { useEffect } from "react";

const NationalUniversitySelectField = ({ labelCode, idFieldName, nameFieldName, required, disabled = false }) => {
  const { setValue } = useFormContext();

  const universityId = useWatch({ name: idFieldName });
  useWatch({ name: nameFieldName });

  const nationalUniversitiesThunk = useAppSelector((state) => {
    return state.AppData.nationalUniversities;
  });

  const selectSelectedOption = (fieldValue) => {
    if (fieldValue && isArrayNotEmpty(nationalUniversitiesThunk.data)) {
      return nationalUniversitiesThunk.data.find((element) => element.id === fieldValue);
    }
    return null;
  };

  useEffect(() => {
    if (universityId !== "" && isArrayNotEmpty(nationalUniversitiesThunk.data)) {
      const uni = nationalUniversitiesThunk.data.find((element) => element.id === universityId);
      setValue(nameFieldName, uni.name);
    }
  }, [universityId, nationalUniversitiesThunk.data, setValue, nameFieldName]);

  return (
    <NomenclatureAutocompleteFormField
      onlyActive
      disabled={disabled}
      required={required}
      fieldName={idFieldName}
      labelCode={labelCode}
      thunkFn={nationalUniversitiesDataThunk}
      thunkState={nationalUniversitiesThunk}
      initialValue={universityId}
      previousOptionValueFn={selectSelectedOption}
    />
  );
};
export default NationalUniversitySelectField;
